import { debounce } from "lodash"
import { nextTick } from "vue";
const getTableHeight = (el, binding,vNode) => {
  nextTick(()=>{
    try {
      const { context } = vNode
      const { page, pEl, setHeight } = binding.value
      const pageDom = page?document.querySelector(page):context.$el
      const contentDom = pageDom.querySelector(pEl)
      if(pageDom&&contentDom&&el){
        const oHeight = contentDom.offsetHeight - el.offsetHeight
        const tableHeight = pageDom.offsetHeight - oHeight
        setHeight(tableHeight)
      }else{
        console.log("page、pEl、el有元素不存在了！");
      }
    } catch (error) {
      console.log(error);
    }
  })
}
export default {
  bind(el, binding,vNode) {
    const handler = debounce(getTableHeight, 100)
    el._debounce = ()=>{
      handler(el, binding,vNode)
    }
    window.addEventListener("resize", el._debounce)
    getTableHeight(el, binding,vNode)
  },
  update(el, binding,vNode) {
    getTableHeight(el, binding,vNode)
  },
  unbind(el) {
    if(el._debounce){
      window.removeEventListener("resize", el._debounce)
      delete el._debounce
    }
  }
}
